<!-- Estructura simplificada para coincidir con el diseño de una sola tarjeta blanca -->
<div class="plan-card">
  <button class="plan-toggle-button" (click)="toggleExpanded()" [attr.aria-expanded]="isExpanded()"
    aria-label="Expandir o contraer detalles del plan" type="button">
    <h2 class="plan-card__title">Resumen de tu compra</h2>
    <svg class="toggle-arrow" [class.expanded]="isExpanded()" width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>
  <!-- Título y vehículo -->
  <!-- <h2 class="plan-card__title">{{ planTitle() }}</h2> -->
  <!-- <p class="plan-card__vehicle">
    <span class="vehicle-brand">{{ vehicleBrand() }}</span>
    <span class="vehicle-line">{{ vehicleLine() }}</span>
  </p> -->
  <div class="plan-card__header-content">
    <div class="plan-card__image">
      <img src="./assets/img/Membresia_moto.png" alt="Tu Moto" />
    </div>


    @if (owner(); as ownerData) {
    <div class="owner-section">
      <p class="owner-section__text"><strong>Marca:</strong> {{ vehicleBrand() }}</p>
      <p class="owner-section__text"><strong>Placa:</strong> {{ vehicleLine() }}</p>
      <p class="owner-section__text"><strong>Dueño:</strong> {{ ownerData.fullname }}</p>
      <p class="owner-section__text"><strong>Documento:</strong> {{ ownerData.document.number }}</p>
      @if (city()) {
      <p class="owner-section__text"><strong>Ciudad:</strong> {{ city() }}</p>
      }
    </div>
    }
  </div>
  @if (isExpanded()) {
  <hr class="plan-divider" />
  <!-- Información del propietario con el nuevo @if -->
  <div class="plan-selected-info">
    <!-- @if (isExpanded()) { -->
    <h2 class="plan-card__title m-0">Plan elegido</h2>
    <div class="plan-details">
      <div class="plan-info-row">
        <span class="plan-info-row__label">{{ planTitle() }}</span>
        @if (planTitle() === 'Plan Premium') {
        <span class="plan-info-row__badgeArmaPlan">A tu medida</span>
        }
        @if (planTitle() === 'Plan Esencial') {
        <span class="plan-info-row__badgePlanEsencial">Más económico</span>
        }
        @if (planTitle() === 'Plan Total') {
        <span class="plan-info-row__badgePlanPlus">Más elegido</span>
        }

      </div>

      <div class="plan-info-row">
        <span class="plan-info-row__label">Forma de pago</span>
        <span class="plan-info-row__value text-bold">{{ paymentType() }}</span>
      </div>

      <div class="plan-info-row">
        <span class="plan-info-row__label-main">Valor total del seguro</span>
        <span class="plan-info-row__price">${{ formatPrice(totalAmount()) }}</span>
      </div>
      @if(paymentType() === 'Mensual') {
      <div class="plan-info-row">
        <span class="plan-info-row__label">Valor pago mensual</span>
        <span class="plan-info-row__value text-bold">${{ formatPrice(monthlyAmount()) }}</span>
      </div>
      }
    </div>

    <!-- Sección de coberturas -->
    <div class="coverages-section">
      @if (coverageLabels().length > 0) {
      <h3 class="coverages-section__title">Estas son las principales coberturas de tu plan:</h3>

      <ul class="coverages-list">
        @for (etiqueta of coverageLabels(); track etiqueta) {
        <li class="coverage-item">
          <span class="coverage-item__text">{{ etiqueta }}</span>
        </li>
        }
      </ul>
      }

      @if (optionalCoverageLabels().length > 0) {
      <h4 class="coverages-section__optional-title">Agregaste esta cobertura opcional:</h4>
      <ul class="coverages-list">
        @for (etiqueta of optionalCoverageLabels(); track etiqueta) {
        <li class="coverage-item">
          <span class="coverage-item__text">{{ etiqueta }}</span>
        </li>
        }
      </ul>
      }
    </div>
    <br />
    <hr class="plan-divider" />

    <div class="payment-summary">
      @if (paymentType() === 'Mensual') {
      <div class="payment-summary__content">
        <h2 class="payment-summary__title">Hoy pagas</h2>
        <span class="payment-summary__subtitle d-block d-md-none">Corresponde a tu primer mes <br> IVA incluido</span>
        <span class="payment-summary__subtitle d-none d-md-block">Corresponde a tu primer mes - IVA incluido</span>
      </div>
      <div class="payment-summary__amount">
        ${{ monthlyAmount() | number:'1.0-0' }}
      </div>
      } @else {
      <div class="payment-summary__content">
        <h2 class="payment-summary__title">Hoy pagas</h2>
        <span class="payment-summary__subtitle">IVA incluido</span>
      </div>
      <div class="payment-summary__amount">
        ${{ totalAmount() | number:'1.0-0' }}
      </div>
      }
    </div>
  </div>
  }